'use client'

import { useState, useEffect } from 'react'
import Footer from '@/components/home/Footer'

export default function BlogFooter() {
  const [isMobile, setIsMobile] = useState(false)

  useEffect(() => {
    const check = () => setIsMobile(window.innerWidth < 768)
    check()
    window.addEventListener('resize', check)
    return () => window.removeEventListener('resize', check)
  }, [])

  return <Footer isMobile={isMobile} />
}
